import { FC } from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";
import __ from "src/utils/Translations";
import getImportSkippedRowReason from "src/utils/Company/Absences/getImportSkippedRowReason";
import { ISkippedRow } from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecords.models";

interface ImportSkippedRowListProps {
  skippedRows: ISkippedRow[];
}

const ImportSkippedRowList: FC<ImportSkippedRowListProps> = ({
  skippedRows,
}) => (
  <>
    <Typography
      variant="subtitle1"
      component="h3"
      sx={{ mt: "1.5rem", mb: "1rem" }}
    >
      {__("Pominięte wiersze")}:
    </Typography>
    {skippedRows.map((skippedRow) => (
      <div
        key={skippedRow.number}
        data-testid="absences-import-skipped-row-list"
      >
        <Stack
          direction="row"
          spacing={4}
          sx={{
            alignItems: "center",
          }}
          data-testid="absences-import-skipped-row-list__item"
        >
          <Box sx={{ flexBasis: "70%" }}>
            <Typography variant="body2">
              {getImportSkippedRowReason(skippedRow.reason)}
            </Typography>
          </Box>
          <Box sx={{ flexBasis: "70%" }}>
            <Typography variant="body2">
              {__("Wiersz")}: <strong>{skippedRow.number}</strong>
            </Typography>
          </Box>
        </Stack>
        <Divider sx={{ m: "0.5rem 0" }} />
      </div>
    ))}
  </>
);

export default ImportSkippedRowList;
